import React from 'react';
import PageLayout from '../components/PageLayout';
import AllowanceSettings from '../components/expenses/AllowanceSettings';

interface AllowanceSettingsPageProps {
  onLogout: () => void;
  onNavigate: (page: string) => void;
}

const AllowanceSettingsPage: React.FC<AllowanceSettingsPageProps> = ({ onLogout, onNavigate }) => {
  return (
    <PageLayout onLogout={onLogout} currentPage="allowance-settings" onNavigate={onNavigate}>
      <div className="p-4 md:p-8">
        <div className="max-w-7xl mx-auto">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900">Allowance Settings</h1>
            <p className="text-blue-600 mt-1">Configure travel allowances, fare charts, and role-based allowances</p>
          </div>
          <AllowanceSettings />
        </div>
      </div>
    </PageLayout>
  );
};

export default AllowanceSettingsPage;
